import _ from 'lodash';
import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { flashMessage } from '../actions';
import { DATA_LOAD_SUCCESS } from '../constants/actionTypes';

const delay = ms => (
    new Promise(resolve => {
        setTimeout(() => resolve(), ms);
    })
);

function *handleFlashMessage(id, messageId, titleId='', ttl = 1500, theme = '') {
    yield put(flashMessage.set(id,messageId, titleId, theme, ttl));
    yield delay(ttl);
    yield put(flashMessage.remove(id));
}

function *_handleServerSuccess({payload:{resource, message}}) {
    if (message) {
        yield handleFlashMessage(resource, message);
    }
}


export function *flashMessageOnServerSuccess() {
    yield takeEvery(DATA_LOAD_SUCCESS, _handleServerSuccess);
}